import {FileManagerTypes, fileTypes} from "../../../component/fileManager/FileManager";
import React, {useEffect, useState} from "react";
import MediaItemShimmer from "../mediaItemShimmer/MediaItemShimmer";
import MediaItemsModel from "../mediaItemsPicture/MediaItemsModel";
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import UploadVideoFile from "../uploadVideoFile/UploadVideoFile";
import UploadImageFile from "../uploadImageFile/UploadImageFile";
import "./FileManagerSelector.scss"
import {css} from "@emotion/css";
import UploadAudioFile from "../uploadAudioFile/UploadAudioFile";
import {
    DialogSize, RaikoButtonPrimary,
    RaikoDefaultDialogPage, RaikoErrorSection,
    RaikoGridOneColumn, RaikoPagination,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";

export default function FileManagerSelector(
    {
        bucketId = FileManagerTypes.POST_IMAGES.id,
        setSelectedFileUrl,
        setOpenDialog
    }
) {

    let page = 0;
    const size = 15;

    const service = new FileManagerService()

    const [itemCount, setItemCount] = useState(0)
    const [fileManagerItemsLoadingState, setFileManagerItemsLoadingState] = useState(true);
    const [fileItems, setFileItems] = useState([]);
    const [pageCount, setPageCount] = useState(0)

    function detectFileType() {

        return fileItems.map((item, index) => {
            return <MediaItemsModel
                id={item.id}
                name={item.name}
                url={item.url}
                size={item.size}
                uploadedAt={item.uploadedAt}
                uploadedBy={item.uploadedBy}
                type={FileManagerTypes[bucketId].type}
                refreshList={_ => {
                    getFilesFromServer()
                }}
                isSelector={true}
                onClick={_ => {
                    setSelectedFileUrl(item.id, item.url)
                    setOpenDialog(false)
                }}
            />
        })
    }


    useEffect(() => {
        if (bucketId && bucketId.length > 0) {
            getFilesFromServer()
        }
    }, [bucketId]);

    function getFilesFromServer() {
        setFileManagerItemsLoadingState(true)
        setItemCount(0)

        service.getFiles(
            bucketId,
            page, size
        ).then(response => {

            setItemCount(response.numberOfItems)
            setFileItems([])
            setPageCount(response.totalPage)

            response.data.map((item, index) => {
                setFileItems(prev => [
                    ...prev,
                    {
                        name: item.metadata.fileName,
                        id: item.metadata.id,
                        size: item.metadata.size,
                        uploadedAt: item.metadata.uploadedAt,
                        uploadedBy: item.metadata.uploadedBy,
                        url: item.urls.downloadUrl,
                    }
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setFileManagerItemsLoadingState(false)
        })
    }

    const [uploadVideoDialog, setUploadVideoDialog] = useState(false);
    const [uploadAudioDialog, setUploadAudioDialog] = useState(false);
    const [uploadImageDialog, setUploadImageDialog] = useState(false);


    function handleUploadNewFile() {
        switch (FileManagerTypes[bucketId].type) {
            case fileTypes.VIDEO:
                setUploadVideoDialog(true)
                break;
            case fileTypes.IMAGE:
                setUploadImageDialog(true)
                break;
            case fileTypes.AUDIO:
                setUploadAudioDialog(true)
                break;

        }
    }

    function handleRefreshList(newItem) {
        setItemCount(itemCount + 1)

        if (uploadImageDialog) {
            setUploadImageDialog(false)
            setFileItems(prev => [
                {
                    name: newItem.metadata.fileName,
                    id: newItem.metadata.id,
                    size: newItem.metadata.size,
                    uploadedAt: newItem.metadata.uploadedAt,
                    uploadedBy: newItem.metadata.uploadedBy,
                    url: newItem.urls.downloadUrl,
                },
                ...prev
            ])
        } else {
            setUploadVideoDialog(false)
            setUploadAudioDialog(false)

            setFileItems(prev => [
                {
                    name: newItem.metadata.fileName,
                    id: newItem.metadata.id,
                    size: newItem.metadata.size,
                    uploadedAt: newItem.metadata.uploadedAt,
                    uploadedBy: newItem.metadata.uploadedBy,
                    url: newItem.urls.streamUrl,
                },
                ...prev
            ])
        }
    }
    function handlePagination(newPage) {
        page = newPage
        getFilesFromServer()
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadVideoDialog(false)
                }}
                open={uploadVideoDialog}
                pageTitle={"بارگزاری ویدیو جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadVideoFile handleRefreshList={handleRefreshList}/>

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadAudioDialog(false)
                }}
                open={uploadAudioDialog}
                pageTitle={"بارگزاری صوت جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadAudioFile handleRefreshList={handleRefreshList}/>

            </RaikoDefaultDialogPage>

            <RaikoDefaultDialogPage
                onClose={_ => {
                    // page = 0
                    // getFilesFromServer()
                    setUploadImageDialog(false)
                }}
                open={uploadImageDialog}
                pageTitle={"بارگزاری تصویر جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}>

                <UploadImageFile
                    handleRefreshList={handleRefreshList}
                    uploadUrl={bucketId && bucketId.length > 0 ? FileManagerTypes[bucketId].uploadUrl : ""}/>

            </RaikoDefaultDialogPage>

            <RaikoGridOneColumn className={"baseFileManagerSelectorContainer"}>

                <div className={`listTitleContainer`}>
                    <div className={"infoContainer"}>
                        {
                            <span className={"subtitle"}>{`${itemCount} فایل بارگزاری شده`}</span>
                        }
                    </div>
                    <RaikoButtonPrimary label={"آپلود"} onClick={handleUploadNewFile}/>
                </div>

                {
                    fileManagerItemsLoadingState ?
                        <MediaItemShimmer/> :
                        fileItems && fileItems.length > 0 && !fileManagerItemsLoadingState ?
                            <RaikoGridOneColumn className={css`gap: .75rem`}>
                                {detectFileType()}
                            </RaikoGridOneColumn>
                            :
                            <RaikoErrorSection
                                title={"هیچ فایلی یافت نشد"}
                            >
                                <div
                                    className={css`
                                      display: flex;
                                      justify-content: center;
                                      align-items: center;`}
                                >
                                    <RaikoButtonPrimary label={"آپلود"} onClick={handleUploadNewFile}/>
                                </div>
                            </RaikoErrorSection>
                }
                <RaikoPagination pageCount={pageCount} handlePaginationChange={handlePagination}/>

            </RaikoGridOneColumn>


        </>
    )
}